
import { all_routes } from '../../router/all_routes'
import ImageWithBasePath from '../../../core/common/imageWithBasePath'
import CommonSelect from '../../../core/common/commonSelect'
import { priority } from '../../../core/common/selectoption/selectoption'
import CommonTagsInput from '../../../core/common/Taginput'
import CommonTextEditor from '../../../core/common/textEditor'
import CollapseHeader from '../../../core/common/collapse-header/collapse-header'
import { getAllProjects, ProjectAPIResponse, ProjectTableData, transformProjectData } from '../../../core/api/useProject'
import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Table as AntTable, DatePicker } from "antd";
import Select from "react-select";
import dayjs from "dayjs";
import { Modal } from 'bootstrap';
import {
  fetchProjectTableData,
  createProject,
  deleteProject,
} from "../../../core/api/useProject";
import {
  fetchProjectMappingLeaders,
  fetchProjectEmployees,
  Employee,
} from "../../../core/api/useProjectMapping";
import { API_BASE_PATH } from "../../../environment";
import {
  ClientListFormatted,
  fetchClientListDetails,
} from "../../../core/api/useClient";
import { toast } from "react-toastify";
import { getTasksByProjectId } from '../../../core/api/useTask'
import { useAuthToken } from '../../../core/data/redux/useAuthToken'
export type Option = {
  label: string;
  value: string;
};

const BASE_URL = API_BASE_PATH;
const MAX_FILE_SIZE_MB = 4;

const statusChoose: Option[] = [
  { label: "Pending", value: "Pending" },
  { label: "Active", value: "Active" },
  { label: "Completed", value: "Completed" },
];

const priorityOptions: Option[] = [
  { value: "Critical", label: "Critical" },
  { value: "High", label: "High" },
  { value: "Medium", label: "Medium" },
  { value: "Low", label: "Low" },
];

const Project = () => {
  const [projects, setProjects] = useState<ProjectTableData[]>([]);
  const [taskStats, setTaskStats] = useState<{ [key: string]: { completed: number; total: number } }>({});
  const descriptionRef = useRef<any>(null);
  const memberTabRef = useRef<HTMLButtonElement>(null);
  const [clientList, setClientList] = useState<ClientListFormatted[]>([]);
  const getModalContainer = () => document.body;
  const [projectLogo, setProjectLogo] = useState<File | null>(null);
  const [imagePreview, setImagePreview] = useState<string | null>(null);
  const [imageError, setImageError] = useState<string | null>(null);
  const [dateError, setDateError] = useState("");
  const [estimatedError, setEstimatedError] = useState("");
  const [data, setData] = useState<ProjectTableData[]>([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [projectToDelete, setProjectToDelete] =
    useState<ProjectTableData | null>(null);
  const [loading, setLoading] = useState(true);
  const [teamMembers, setTeamMembers] = useState<Option[]>([]);
  const [teamLeader, setTeamLeader] = useState<Option[]>([]);
  const [projectManager, setProjectManager] = useState<Option[]>([]);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [deadlineError, setDeadlineError] = useState("");
  const [projectName, setProjectName] = useState("");
  const [clientId, setClientId] = useState("");
  const [priority, setPriority] = useState("");
  const [projectType, setProjectType] = useState("Gold");
  const [projectValue, setProjectValue] = useState("");
  const [priceType, setPriceType] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [deadline, setDeadline] = useState("");
  const [remarks, setRemarks] = useState("");
  const [status, setStatus] = useState("");
  const [uploadFile, setUploadFile] = useState<File | null>(null);
  const [fileError, setFileError] = useState("");
    const empToken = useAuthToken();

  const [employeeOptions, setEmployeeOptions] = useState<Option[]>([]);
  const [tags, setTags] = useState<Option[]>([]);

  const [estimatedHours, setEstimatedHours] = useState("");
  const [totalHours, setTotalHours] = useState("");
  const [actualHours, setActualHours] = useState("");
  const [projectVersion, setProjectVersion] = useState("");
  const [projectProgress, setProjectProgress] = useState("");
  const [managerMap, setManagerMap] = useState<Record<string, string>>({});

  const resetForm = () => {
    setProjectName('');
    setClientId('');
    setStartDate('');
    setEndDate('');
    setPriority('');
    setProjectValue('');
    setPriceType('');
    setTotalHours('');
    setEstimatedHours('');
    setRemarks('');
    setDeadline('');
    setUploadFile(null);
    setTeamMembers([]);
    setTeamLeader([]);
    setProjectManager([]);
    setTags([]);
    setStatus('');
    setImagePreview('');

    if (descriptionRef.current) {
      descriptionRef.current.resetContent?.(); // assuming your CommonTextEditor has this method
    }
  };


  const [employeeDetailsMap, setEmployeeDetailsMap] = useState<
    Record<string, Employee>
  >({});

  useEffect(() => {
    fetchProjectEmployees().then((employees) => {
      const map: Record<string, string> = {};
      employees.forEach((emp) => {
        map[emp.employee_id] = emp.username;
      });
      setManagerMap(map);
    });
  }, []);




  useEffect(() => {
    fetchProjectTableData()
      .then((projectData) => {
        setData(projectData);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Failed to fetch project data:", error);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    fetchProjectEmployees()
      .then((employees: Employee[]) => {
        const options = employees.map((emp) => ({
          label: `${emp.username} Dep : ${emp.department} | Des : ${emp.designation}`,
          value: emp.employee_id,
        }));
        setEmployeeOptions(options);

        const detailsMap: Record<string, Employee> = {};
        employees.forEach((emp) => {
          detailsMap[emp.employee_id] = emp;
        });
        setEmployeeDetailsMap(detailsMap);
      })
      .catch((err) => {
        console.error("Failed to fetch project employees", err);
      });
  }, []);

  useEffect(() => {
    const getClients = async () => {
      const clients = await fetchClientListDetails();
      setClientList(clients);
    };

    getClients();
  }, []);
  useEffect(() => {
    const fetchAllTaskStats = async () => {
      const stats: { [key: string]: { completed: number; total: number } } = {};

      for (const project of projects) {
        try {
          const tasks = await getTasksByProjectId(empToken,project.ProjectID);
          const completed = tasks.filter((task) => task.status.toLowerCase() === "completed").length;
          stats[project.ProjectID] = {
            completed,
            total: tasks.length,
          };
        } catch (error) {
          console.error(`Error fetching tasks for project ${project.ProjectID}:`, error);
          stats[project.ProjectID] = { completed: 0, total: 0 };
        }
      }

      setTaskStats(stats);
    };

    if (projects.length > 0) {
      fetchAllTaskStats();
    }
  }, [projects]);


  const handleSubmit = async () => {
    const formData = new FormData();
    setIsSubmitted(true);
    formData.append("project_name", projectName || "");
    formData.append("project_type", projectType || "");
    formData.append("priority", priority || "");
    formData.append("status", status || "");
    formData.append("client_id", clientId || "");
    formData.append("price_type", priceType || "");
    formData.append(
      "description",
      descriptionRef.current?.getContent?.() || ""
    );
    formData.append("project_version", projectVersion || "");
    formData.append("Project_progress", projectProgress || "");
    formData.append("remarks", remarks || "");
    formData.append("project_value", projectValue || "0");
    formData.append("estimated_hours", estimatedHours || "0");
    formData.append("total_hours", totalHours || "0");
    formData.append("actual_hours", actualHours || "0");

    // ✅ Flatten member, lead, manager values
    if (teamMembers.length) {
      formData.append(
        "project_member",
        teamMembers.map((m) => m.value).join(",")
      );
    }
    if (teamLeader.length) {
      formData.append("project_lead", teamLeader.map((m) => m.value).join(","));
    }
    if (projectManager.length) {
      formData.append(
        "project_manager",
        projectManager.map((m) => m.value).join(",")
      );
    }

    // ✅ Dates
    if (deadline)
      formData.append("deadline", dayjs(deadline).format("YYYY-MM-DD"));
    if (startDate)
      formData.append("start_date", dayjs(startDate).format("YYYY-MM-DD"));
    if (endDate)
      formData.append("end_date", dayjs(endDate).format("YYYY-MM-DD"));

    // ✅ Tags
    if (tags?.length)
      formData.append("tags", tags.map((t) => t.value).join(","));

    // ✅ Files
    if (projectLogo) formData.append("logo", projectLogo);
    if (uploadFile) formData.append("upload_file", uploadFile);


    try {
      const response = await createProject(formData);
      if (response) {
        const refreshedData = await fetchProjectTableData();
        setData(refreshedData);
        setShowAddModal(false);
      }
    } catch (err) {
      console.error("Project creation failed:", err);
    }

    resetForm();

  };

  const handleDelete = async () => {
    if (!projectToDelete) return;
    const success = await deleteProject(projectToDelete.ProjectID);

    if (success) {
      const updatedData = await fetchProjectTableData();
      setData(updatedData);
      setShowDeleteModal(false);
      setProjectToDelete(null);
    }
  };
  const columns = [
    {
      title: "Project",
      dataIndex: "ProjectName",
      render: (text: string, record: any) => (
        <div>
          <h4 className="fw-medium">
            <Link to={all_routes.projectdetails}>{record.ProjectName}</Link>
          </h4>
          <div>
            <span className="fs-12 fw-normal text-muted">
              <Link to={all_routes.projectdetails}>{record.ProjectID}</Link>
            </span>
          </div>
          <span className="fs-12 fw-normal text-muted">
            {record.ProjectType}
          </span>
        </div>
      ),
      sorter: (a: any, b: any) => a.ProjectName.length - b.ProjectName.length,
    },
    {
      title: "Client Name",
      dataIndex: "Client Name",
      render: (text: string, record: any) => (
        <div className="d-flex align-items-center">
          <Link
            to={all_routes.clientdetils}
            state={{ clientId: record.Client_ID }}
            className="avatar avatar-sm border avatar-rounded me-3"
          >
            <img
              src={`${BASE_URL}/client/client/${record.Client_ID}/image`}
              className="img-fluid"
              alt="/assets/img/defaultavatar.png"
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.onerror = null;
                target.src = "/assets/img/defaultavatar.png";
              }}
            />
          </Link>
          <div className="d-flex flex-column">
            <h6 className="fw-medium mb-0">
              <Link to={all_routes.clientdetils}>{record.Client}</Link>
            </h6>
            <span className="fs-12 fw-normal text-muted">{record.Work}</span>
          </div>
        </div>
      ),
      sorter: (a: any, b: any) => a.ProjectName.length - b.ProjectName.length,
    },
    {
      title: "Manager",
      dataIndex: "Manager",
      render: (_: string, record: any) => {
        let managers: string[] = [];

        const rawValue =
          typeof record.ProjectManagers === "object" &&
            record.ProjectManagers !== null
            ? Object.values(record.ProjectManagers).join(",")
            : "";

        if (rawValue) {
          managers = rawValue
            .split(",")
            .map((id) => id.trim())
            .filter(Boolean);
        }

        managers.forEach((id) => {
          const imgUrl = `${BASE_URL}/register/employee/${id}/image`;
        });

        return (
          <div className="d-flex flex-wrap gap-1">
            {managers.map((id: string, index: number) => (
              <div
                key={index}
                className="bg-gray-100 p-1 rounded d-flex align-items-center me-2"
              >
                <Link
                  to="#"
                  className="avatar avatar-sm avatar-rounded border border-white flex-shrink-0 me-2"
                >
                  <img
                    src={`${BASE_URL}/register/employee/${id}/image`}
                    alt="/assets/img/defaultavatar.png"
                    onError={(e) => {
                      const target = e.target as HTMLImageElement;
                      target.onerror = null;
                      target.src = "/assets/img/defaultavatar.png";
                    }}
                  />
                </Link>
                <h6 className="fs-12 mb-0">
                  <Link to="#">{managerMap[id] || id}</Link>
                </h6>
              </div>
            ))}
          </div>
        );
      },
      sorter: (a: any, b: any) => {
        const aRaw =
          typeof a.ProjectManagers === "object" && a.ProjectManagers !== null
            ? Object.values(a.ProjectManagers).join(",")
            : "";
        const bRaw =
          typeof b.ProjectManagers === "object" && b.ProjectManagers !== null
            ? Object.values(b.ProjectManagers).join(",")
            : "";

        return aRaw.length - bRaw.length;
      },
    },
    {
      title: "Leader",
      dataIndex: "Leader",
      render: (_: string, record: any) => {
        let leads: string[] = [];

        const rawValue =
          typeof record.ProjectLeads === "object" &&
            record.ProjectLeads !== null
            ? Object.values(record.ProjectLeads).join(",")
            : "";

        if (rawValue) {
          leads = rawValue
            .split(",")
            .map((id) => id.trim())
            .filter(Boolean);
        }
        return (
          <div className="avatar-list-stacked avatar-group-sm">
            {leads.map((id: string, index: number) => (
              <span key={index} className="avatar avatar-rounded">
                <img
                  className="border border-white"
                  src={`${BASE_URL}/register/employee/${id}/image`}
                  alt="/assets/img/defaultavatar.png"
                  onError={(e) => {
                    const target = e.target as HTMLImageElement;
                    target.onerror = null;
                    target.src = "/assets/img/defaultavatar.png";
                  }}
                />
              </span>
            ))}

            {leads.length > 0 && (
              <Link
                className="avatar bg-primary avatar-rounded text-fixed-white fs-12 fw-medium"
                to="#"
              >
                +{leads.length}
              </Link>
            )}
          </div>
        );
      },
      sorter: (a: any, b: any) => {
        const aRaw =
          typeof a.ProjectLeads === "object" && a.ProjectLeads !== null
            ? Object.values(a.ProjectLeads).join(",")
            : "";
        const bRaw =
          typeof b.ProjectLeads === "object" && b.ProjectLeads !== null
            ? Object.values(b.ProjectLeads).join(",")
            : "";

        return aRaw.length - bRaw.length;
      },
    },
    {
      title: "Team",
      dataIndex: "Team",
      render: (_: string, record: any) => {
        let members: string[] = [];

        const rawValue =
          typeof record.ProjectMembers === "object" &&
            record.ProjectMembers !== null
            ? Object.values(record.ProjectMembers).join(",")
            : "";

        if (rawValue) {
          members = rawValue
            .split(",")
            .map((id) => id.trim())
            .filter(Boolean);
        }
        return (
          <div className="avatar-list-stacked avatar-group-sm">
            {members.map((id: string, index: number) => (
              <span key={index} className="avatar avatar-rounded">
                <img
                  className="border border-white"
                  src={`${BASE_URL}/register/employee/${id}/image`}
                  alt="/assets/img/defaultavatar.png"
                  onError={(e) => {
                    const target = e.target as HTMLImageElement;
                    target.onerror = null;
                    target.src = "/assets/img/defaultavatar.png";
                  }}
                />
              </span>
            ))}

            {members.length > 0 && (
              <Link
                className="avatar bg-primary avatar-rounded text-fixed-white fs-12 fw-medium"
                to="#"
              >
                +{members.length}
              </Link>
            )}
          </div>
        );
      },
      sorter: (a: any, b: any) =>
        (Array.isArray(a.ProjectMembers) ? a.ProjectMembers.length : 0) -
        (Array.isArray(b.ProjectMembers) ? b.ProjectMembers.length : 0),
    },
    {
      title: "Deadline",
      dataIndex: "Deadline",
      sorter: (a: any, b: any) => a.Deadline.length - b.Deadline.length,
    },
    {
      title: "Priority",
      dataIndex: "Priority",
      render: (text: String, record: any) => (
        <div className="dropdown">
          <Link
            to="#"
            className="btn btn-sm btn-white d-inline-flex align-items-center"
            data-bs-toggle="dropdown"
          >
            <span
              className={`rounded-circle  d-flex justify-content-center align-items-center me-2${text === "High"
                ? "bg-transparent-danger"
                : text === "Low"
                  ? "bg-transparent-success"
                  : "bg-transparent-warning"
                }`}
            >
              <i
                className={`ti ti-point-filled ${text === "High"
                  ? "text-danger"
                  : text === "Low"
                    ? "text-success"
                    : "text-warning"
                  }`}
              />
            </span>{" "}
            {text}
          </Link>
        </div>
      ),
      sorter: (a: any, b: any) => a.Priority.length - b.Priority.length,
    },
    {
      title: "Status",
      dataIndex: "Status",
      render: (text: string, record: any) => (
        <span
          className={`badge  ${text === "Active" ? "badge-success" : "badge-danger"
            } d-inline-flex align-items-center badge-xs`}
        >
          <i className="ti ti-point-filled me-1" />
          {text}
        </span>
      ),
      sorter: (a: any, b: any) => a.Status.length - b.Status.length,
    },
    {
      title: "",
      dataIndex: "actions",
      render: (_: any, record: ProjectTableData) => (
        <div className="action-icon d-inline-flex">
          <Link
            to={all_routes.projectdetails}
            state={{
              Project: record,
              employeeMap: employeeDetailsMap,
              memberMapping: record.ProjectMembers,
              leaderMapping: record.ProjectLeads,
              managerMapping: record.ProjectManagers,
            }}
            className="me-2"
            data-inert={true}
          >
            <i className="ti ti-edit" />
          </Link>
          <Link
            to="#"
            data-bs-toggle="modal"
            data-inert={true}
            data-bs-target="#delete_modal"
            onClick={() => {
              setProjectToDelete(record); // ✅ Now it's defined
              setShowDeleteModal(true);
            }}
          >
            <i className="ti ti-trash" />
          </Link>
        </div>
      ),
    },
  ];
  const handleSingleSelect =
    (setter: (val: string) => void) => (selected: unknown) => {
      if (selected) setter((selected as Option).value);
    };

  const handleMultiSelect =
    (setter: (val: Option[]) => void) => (selected: unknown) => {
      setter(selected as Option[]);
    };

  const allowedExtensions = ["jpg", "jpeg", "png", "webp"];
  const maxFileSizeMB = 4;

  const handleLogoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const fileExtension = file.name.split(".").pop()?.toLowerCase();
    const isImageType = file.type.startsWith("image/");
    const isValidExtension = fileExtension && allowedExtensions.includes(fileExtension);

    // ❌ Invalid file type
    if (!isImageType || !isValidExtension) {
      setImageError("Only JPG, JPEG, PNG, or WEBP image files are allowed.");
      setProjectLogo(null);
      setImagePreview(null);
      e.target.value = ""; // allow same file re-upload
      return;
    }

    // ❌ File too large
    if (file.size > maxFileSizeMB * 1024 * 1024) {
      setImageError("Image should be less than 4MB.");
      setProjectLogo(null);
      setImagePreview(null);
      e.target.value = "";
      return;
    }

    // ✅ Valid file
    setProjectLogo(file);
    setImageError(null);

    const reader = new FileReader();
    reader.onloadend = () => {
      setImagePreview(reader.result as string);
    };
    reader.readAsDataURL(file);
  };


  const handleCancel = () => {
    setProjectLogo(null);
    setImagePreview(null);
    setImageError(null);
  };

  const validateDateRange = (start: string, end: string) => {
    if (start && end && new Date(end) <= new Date(start)) {
      setDateError("End Date must be greater than Start Date.");
    } else {
      setDateError("");
    }
  };


  const [tags1, setTags1] = useState<string[]>(["Hendry", "James"]);
  const [tags2, setTags2] = useState<string[]>(["Dwight"]);
  const [tags3, setTags3] = useState<string[]>(["Collab", "Promotion", "Rated"]);



  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await getAllProjects();
        if (response) {
          const transformed = transformProjectData(response);
          setProjects(transformed);
        }
      } catch (error) {
        console.error("Error fetching projects:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProjects();
  }, []);

  if (loading) {
    return <p>Loading projects...</p>;
  }




  const clinetChoose = [
    { value: "Anthony Lewis", label: "Anthony Lewis" },
    { value: "Brian Villalobos", label: "Brian Villalobos" },
  ];
  const statusChoose = [
    { value: "Select", label: "Select" },
    { value: "Active", label: "Active" },
    { value: "Inactive", label: "Inactive" },
  ];
  const priorityChoose = [
    { value: "Select", label: "Select" },
    { value: "High", label: "High" },
    { value: "Medium", label: "Medium" },
    { value: "Low", label: "Low" },
  ];

  return (
    <>
      <>
        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content">
            {/* Breadcrumb */}
            <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
              <div className="my-auto mb-2">
                <h2 className="mb-1">Projects</h2>
                <nav>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <Link to={all_routes.adminDashboard}>
                        <i className="ti ti-smart-home" />
                      </Link>
                    </li>
                    <li className="breadcrumb-item">Employee</li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Projects Grid
                    </li>
                  </ol>
                </nav>
              </div>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
                <div className="me-2 mb-2">
                  <div className="d-flex align-items-center border bg-white rounded p-1 me-2 icon-list">
                    <Link
                      to={all_routes.projectlist}
                      className="btn btn-icon btn-sm active bg-primary text-white me-1"
                    >
                      <i className="ti ti-list-tree" />
                    </Link>
                    <Link
                      to={all_routes.project}
                      className="btn btn-icon btn-sm"
                    >
                      <i className="ti ti-layout-grid" />
                    </Link>
                  </div>
                </div>
                <div className="me-2 mb-2">
                  <div className="dropdown">
                    <Link
                      to="#"
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      <i className="ti ti-file-export me-1" />
                      Export
                    </Link>
                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      <li>
                        <Link
                          to="#"
                          className="dropdown-item rounded-1"
                        >
                          <i className="ti ti-file-type-pdf me-1" />
                          Export as PDF
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          className="dropdown-item rounded-1"
                        >
                          <i className="ti ti-file-type-xls me-1" />
                          Export as Excel{" "}
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="mb-2">
                  <Link
                    to="#"
                    data-bs-toggle="modal" data-inert={true}
                    data-bs-target="#add_project"
                    className="btn btn-primary d-flex align-items-center"
                  >
                    <i className="ti ti-circle-plus me-2" />
                    Add Project
                  </Link>
                </div>
                <div className="ms-2 head-icons">
                  <CollapseHeader />
                </div>
              </div>
            </div>
            {/* /Breadcrumb */}
            <div className="card">
              <div className="card-body p-3">
                <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                  <h5>Projects Grid</h5>
                  <div className="d-flex align-items-center flex-wrap row-gap-3">
                    <div className="dropdown me-2">
                      <Link
                        to="#"
                        className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                        data-bs-toggle="dropdown"
                      >
                        Select Status
                      </Link>
                      <ul className="dropdown-menu  dropdown-menu-end p-3">
                        <li>
                          <Link
                            to="#"
                            className="dropdown-item rounded-1"
                          >
                            Select Status
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="#"
                            className="dropdown-item rounded-1"
                          >
                            Active
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="#"
                            className="dropdown-item rounded-1"
                          >
                            Inactive
                          </Link>
                        </li>
                      </ul>
                    </div>
                    <div className="dropdown">
                      <Link
                        to="#"
                        className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                        data-bs-toggle="dropdown"
                      >
                        Sort By : Last 7 Days
                      </Link>
                      <ul className="dropdown-menu  dropdown-menu-end p-3">
                        <li>
                          <Link
                            to="#"
                            className="dropdown-item rounded-1"
                          >
                            Recently Added
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="#"
                            className="dropdown-item rounded-1"
                          >
                            Ascending
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="#"
                            className="dropdown-item rounded-1"
                          >
                            Desending
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="#"
                            className="dropdown-item rounded-1"
                          >
                            Last Month
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="#"
                            className="dropdown-item rounded-1"
                          >
                            Last 7 Days
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Project Grid */}
            <div className="row">
              {projects.map((project) => {
                let managerIds: string[] = [];
                const rawValue =
                  typeof project.ProjectManagers === "object" && project.ProjectManagers !== null
                    ? Object.values(project.ProjectManagers).join(",")
                    : "";

                if (rawValue) {
                  managerIds = rawValue
                    .split(",")
                    .map((id) => id.trim())
                    .filter(Boolean);
                }
                // Extract lead and member IDs safely
                const leadIds: string[] = typeof project.ProjectLeads === "string"
                  ? (project.ProjectLeads as string).split(",").map((id: string) => id.trim()).filter(Boolean)
                  : Array.isArray(project.ProjectLeads)
                    ? project.ProjectLeads as string[]
                    : [];

                const memberIds: string[] = typeof project.ProjectMembers === "string"
                  ? (project.ProjectMembers as string).split(",").map((id: string) => id.trim()).filter(Boolean)
                  : Array.isArray(project.ProjectMembers)
                    ? project.ProjectMembers as string[]
                    : [];


                return (
                  <div className="col-xxl-3 col-lg-4 col-md-6" key={project.key}>
                    <div className="card">
                      <div className="card-body">
                        <div className="d-flex align-items-center justify-content-between mb-2">
                          <h6 className="mb-0">
                            <Link
                              to={all_routes.projectdetails}
                              state={{
                                Project: project,
                                projectName: project.ProjectName,
                                projectId: project.ProjectID,
                                employeeMap: employeeDetailsMap,
                                memberMapping: project.ProjectMembers,
                                leaderMapping: project.ProjectLeads,
                                managerMapping: project.ProjectManagers,
                              }}
                            >
                              <span className="d-block">{project.ProjectName}</span>
                              <span className="text-muted small">{project.ProjectID}</span>
                              <p className="text-muted small">{project.ProjectType}</p>
                            </Link>
                          </h6>
                          <div className="dropdown">
                            <Link
                              to="#"
                              className="d-inline-flex align-items-center"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              <i className="ti ti-dots-vertical" />
                            </Link>
                            <ul className="dropdown-menu dropdown-menu-end p-3">
                              <li>
                                <Link
                                  to="#"
                                  className="dropdown-item rounded-1"
                                  data-bs-toggle="modal"
                                  data-bs-target="#edit_project"
                                >
                                  <i className="ti ti-edit me-2" />
                                  Edit
                                </Link>
                              </li>
                              <li>
                                <Link
                                  to="#"
                                  className="dropdown-item rounded-1"
                                  data-bs-toggle="modal"
                                  data-bs-target="#delete_modal"
                                >
                                  <i className="ti ti-trash me-1" />
                                  Delete
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <br></br>

                        <div className="icons-social d-flex align-items-center flex-wrap gap-3">
                          <p className="mb-2 text-truncate">
                            Status:{" "}
                            <span
                              className={`badge ${project.Status === "Active" ? "bg-success" : "bg-danger"}`}
                            >
                              {project.Status}
                            </span>
                          </p>

                          <p className="mb-2 text-truncate">
                            Priority:{" "}
                            <span
                              className={`badge ${project.Priority === "Critical"
                                ? "bg-danger"
                                : project.Priority === "High"
                                  ? "bg-warning"
                                  : project.Priority === "Medium"
                                    ? "bg-info"
                                    : "bg-secondary"
                                }`}
                            >
                              {project.Priority}
                            </span>
                          </p>
                        </div>
                        <br></br>
                        <div className="mb-2" />
                        {/* ✅ Updated Project Managers */}
                        <div className="d-flex align-items-center justify-content-between mb-3 pb-3 border-bottom">
                          <div className="d-flex flex-column">
                            <div className="avatar-list-stacked avatar-group-sm mb-1">
                              {managerIds.map((id, idx) => (
                                <span key={idx} className="avatar avatar-sm avatar-rounded">
                                  <img
                                    className="border border-white"
                                    src={`${BASE_URL}/register/employee/${id}/image`}
                                    alt="/assets/img/defaultavatar.png"
                                    onError={(e) => {
                                      const target = e.target as HTMLImageElement;
                                      target.onerror = null;
                                      target.src = "/assets/img/defaultavatar.png";
                                    }}
                                  />
                                </span>
                              ))}
                            </div>
                            <div className="text-muted fs-12 text-truncate" style={{ maxWidth: "180px" }}>
                              {managerIds.map((id) => managerMap[id] || id).join(", ")}
                            </div>
                          </div>
                          <div className="d-flex align-items-center">
                            <div>
                              <span className="fs-12 fw-normal">Deadline</span>
                              <p className="mb-0 fs-12">{project.Deadline}</p>
                            </div>
                          </div>
                        </div>

                        <div className="d-flex align-items-start justify-content-between">
                          {/* ✅ Task Summary */}
                          <div className="d-flex align-items-center">
                            <span className="avatar avatar-sm avatar-rounded bg-success-transparent flex-shrink-0 me-2">
                              <i className="ti ti-checklist text-success fs-16" />
                            </span>
                            <p className="mb-0">
                              <small>Tasks : </small>
                              <span className="text-dark">
                                {taskStats[project.ProjectID]?.completed ?? 0}
                              </span>
                              /
                              {taskStats[project.ProjectID]?.total ?? 0}
                            </p>
                          </div>

                          {/* ✅ Lead */}
                          <div className="d-flex flex-column align-items-center me-2">
                            <div className="avatar-list-stacked avatar-group-sm mb-1">
                              {leadIds.map((id, idx) => {
                                
                                return (
                                  <span key={idx} className="avatar avatar-sm avatar-rounded">
                                    <img
                                      className="border border-white"
                                      src={`${BASE_URL}/register/employee/${id}/image`}
                                      alt="/assets/img/defaultavatar.png"
                                      onError={(e) => {
                                        const target = e.target as HTMLImageElement;
                                        target.onerror = null;
                                        target.src = "/assets/img/defaultavatar.png";
                                      }}
                                    />
                                  </span>
                                );
                              })}
                            </div>
                            {/* No need for name here, just keep the role title */}
                            <span className="fs-12 fw-normal text-truncate">Lead</span>
                          </div>

                          {/* ✅ Team */}
                          <div className="d-flex flex-column align-items-center ms-2">
                            <div className="avatar-list-stacked avatar-group-sm mb-1">
                              {memberIds.map((id, idx) => {
                               
                                return (
                                  <span key={idx} className="avatar avatar-sm avatar-rounded">
                                    <img
                                      className="border border-white"
                                      src={`${BASE_URL}/register/employee/${id}/image`}
                                      alt="/assets/img/defaultavatar.png"
                                      onError={(e) => {
                                        const target = e.target as HTMLImageElement;
                                        target.onerror = null;
                                        target.src = "/assets/img/defaultavatar.png";
                                      }}
                                    />
                                  </span>
                                );
                              })}
                            </div>
                            {/* No need for name here, just keep the role title */}
                            <span className="fs-12 fw-normal text-truncate">Team</span>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}

              <div className="col-md-12">
                <div className="text-center mb-4">
                  <Link to="#" className="btn btn-primary">
                    <i className="ti ti-loader-3 me-1" />
                    Load More
                  </Link>
                </div>
              </div>
            </div>
            {/* / Project Grid */}
          </div>
          <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
            <p className="mb-0">2024 - 2025 © IATT.</p>
            <p>
              Designed &amp; Developed By{" "}
              <Link to="#" className="text-primary">
                IATT              </Link>
            </p>
          </div>
        </div>
        {/* /Page Wrapper */}
      </>

      {/* Add Project */}
      <div className="modal fade" id="add_project" >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header header-border align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <h5 className="modal-title me-2">Add Project </h5>
              </div>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="add-info-fieldset ">
              <div className="contact-grids-tab p-3 pb-0">
                <ul className="nav nav-underline" id="myTab" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active"
                      id="basic-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#basic-info"
                      type="button"
                      role="tab"
                      aria-selected="true"
                    >
                      Basic Information
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="member-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#member"
                      type="button"
                      role="tab"
                      aria-selected="false"
                      ref={memberTabRef}
                    >
                      Members
                    </button>
                  </li>
                </ul>
              </div>
              <div className="tab-content" id="myTabContent">
                <div
                  className="tab-pane fade show active"
                  id="basic-info"
                  role="tabpanel"
                  aria-labelledby="basic-tab"
                  tabIndex={0}
                >
                  <form>
                    <div className="modal-body">
                      <div className="row">
                        {/* Project Logo */}
                        <div className="col-md-6">
                          <div className="d-flex align-items-center justify-content-center flex-column">
                            {/* Image Preview or Icon */}
                            <div className="d-flex align-items-center flex-wrap row-gap-3 bg-light w-100 rounded p-3 mb-4">
                              {/* Image preview circle */}
                              <div className="d-flex align-items-center justify-content-center avatar avatar-xxl rounded-circle border border-dashed me-2 flex-shrink-0 text-dark frames">
                                {imagePreview ? (
                                  <img
                                    src={imagePreview}
                                    alt="Preview"
                                    className="rounded-circle"
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      objectFit: "cover",
                                    }}
                                  />
                                ) : (
                                  <i className="ti ti-photo text-gray-2 fs-16" />
                                )}
                              </div>

                              {/* Upload Controls */}
                              <div className="profile-upload">
                                <div className="mb-2">
                                  <h6 className="mb-1">Upload Project Logo</h6>
                                  <p className="fs-12">
                                    Image should be below 4 mb
                                  </p>
                                </div>
                                <div className="profile-uploader d-flex align-items-center">
                                  <div className="drag-upload-btn btn btn-sm btn-primary me-2 position-relative overflow-hidden">
                                    Upload
                                    <input
                                      type="file"
                                      accept=".jpg,.jpeg,.png,.webp"
                                      className="form-control image-sign position-absolute start-0 top-0 opacity-0 w-100 h-100"
                                      onChange={handleLogoChange}
                                    />
                                  </div>
                                  {imagePreview && (
                                    <Link
                                      to="#"
                                      className="btn btn-light btn-sm"
                                      onClick={handleCancel}
                                    >
                                      Cancel
                                    </Link>
                                  )}
                                </div>
                                {imageError && (
                                  <p className="text-danger fs-12 mt-1">{imageError}</p>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Project Name */}
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label className="form-label">Project Name</label>
                            <input
                              type="text"
                              className="form-control"
                              value={projectName}
                              onChange={(e) => {
                                const value = e.target.value;
                                const allowed = /^[a-zA-Z0-9@\- ]*$/; // allow letters, digits, @, -, and space

                                if (allowed.test(value)) {
                                  setProjectName(value);
                                }
                              }}
                            />
                            {isSubmitted && !projectName && (
                              <p className="text-danger fs-12 mt-1">Project name is required.</p>
                            )}
                          </div>

                        </div>

                        {/* Client ID */}
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label className="form-label">Client</label>
                            <select
                              className="form-control"
                              value={clientId}
                              onChange={(e) => setClientId(e.target.value)}
                            >
                              <option value="">Select a client</option>
                              {clientList.map((client) => (
                                <option
                                  key={client.key}
                                  value={client.ClientID}
                                >
                                  {client.ClientName} - ({client.ClientID})
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        {/* Start Date */}
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Start Date</label>
                            <DatePicker
                              className="form-control datetimepicker"
                              format="DD-MM-YYYY"
                              getPopupContainer={getModalContainer}
                              placeholder="DD-MM-YYYY"
                              value={startDate ? dayjs(startDate) : null}
                              onChange={(date) => {
                                const start = date ? date.toISOString() : "";
                                setStartDate(start);
                                validateDateRange(start, endDate); // 🔁 Revalidate
                              }}
                            />

                          </div>
                        </div>

                        {/* End Date */}
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">End Date</label>
                            <DatePicker
                              className="form-control datetimepicker"
                              format="DD-MM-YYYY"
                              getPopupContainer={getModalContainer}
                              placeholder="DD-MM-YYYY"
                              value={endDate ? dayjs(endDate) : null}
                              onChange={(date) => {
                                const end = date ? date.toISOString() : "";
                                setEndDate(end);
                                validateDateRange(startDate, end);

                                if (startDate && end && new Date(end) <= new Date(startDate)) {
                                  setDateError("End Date must be greater than Start Date.");
                                } else {
                                  setDateError("");
                                }
                              }}
                            />
                            {dateError && (
                              <p className="text-danger fs-12 mt-1">{dateError}</p>
                            )}
                          </div>
                        </div>

                        {/* Priority */}
                        <div className="col-md-4">
                          <div className="mb-3">
                            <label className="form-label">Priority</label>
                            <Select
                              options={priorityOptions}
                              onChange={handleSingleSelect(setPriority)}
                            />
                          </div>
                        </div>

                        {/* Project Value */}
                        <div className="col-md-4">
                          <div className="mb-3">
                            <label className="form-label">Project Value</label>
                            <input
                              type="number"
                              className="form-control"
                              value={projectValue}
                              onChange={(e) => setProjectValue(e.target.value)}
                            />
                          </div>
                        </div>

                        {/* Price Type */}
                        <div className="col-md-4">
                          <div className="mb-3">
                            <label className="form-label">Price Type</label>
                            <select
                              className="form-control"
                              value={priceType}
                              onChange={(e) => setPriceType(e.target.value)}
                            >
                              <option value="">Select Price Type</option>
                              <option value="Fixed Price">Fixed Price</option>
                              <option value="Time and Materials">Time and Materials</option>
                              <option value="Subscription">Subscription</option>
                            </select>
                          </div>
                        </div>

                        {/* Description */}
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label className="form-label">Description</label>
                            <CommonTextEditor ref={descriptionRef} />
                          </div>
                        </div>

                        {/* Total Hours */}
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Total Hours</label>
                            <input
                              type="number"
                              className="form-control"
                              value={totalHours}
                              onChange={(e) => {
                                const value = e.target.value;

                                // Allow only digits (and optionally one dot if decimals are okay)
                                if (/^\d*\.?\d*$/.test(value)) {
                                  setTotalHours(value);
                                }
                              }}
                            />

                          </div>
                        </div>

                        {/* Estimated Hours */}
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Estimated Hours
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              value={estimatedHours}
                              onChange={(e) => {
                                const value = e.target.value;
                                if (/^\d*$/.test(value)) {
                                  setEstimatedHours(value);
                                  if (totalHours && parseInt(value) >= parseInt(totalHours)) {
                                    setEstimatedError("Estimated Hours must be less than Total Hours");
                                  } else {
                                    setEstimatedError("");
                                  }
                                }
                              }}
                            />
                            {estimatedError && (
                              <p className="text-danger fs-12 mt-1">{estimatedError}</p>
                            )}

                          </div>
                        </div>

                        {/* Remarks */}
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Remarks</label>
                            <input
                              type="text"
                              className="form-control"
                              value={remarks}
                              onChange={(e) => setRemarks(e.target.value)}
                            />
                          </div>
                        </div>

                        {/* Deadline */}
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Deadline</label>
                            <input
                              type="date"
                              className="form-control"
                              value={deadline}
                              onChange={(e) => {
                                const value = e.target.value;
                                setDeadline(value);

                                if (endDate && value >= endDate) {
                                  setDeadlineError("Deadline must be before End Date");
                                } else {
                                  setDeadlineError("");
                                }
                              }}
                            />
                            {deadlineError && (
                              <p className="text-danger fs-12 mt-1">{deadlineError}</p>
                            )}

                          </div>
                        </div>

                        {/* File Upload */}
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label className="form-label">Upload File</label>
                            <input
                              className="form-control"
                              type="file"
                              onChange={(e) => {
                                const file = e.target.files?.[0];
                                if (file) {
                                  if (file.size > 5 * 1024 * 1024) {
                                    setFileError("File must be below 5MB");
                                    e.target.value = "";
                                    setUploadFile(null);
                                  } else {
                                    setUploadFile(file);
                                    setFileError("");
                                  }
                                }
                              }}
                            />
                            {fileError && (
                              <p className="text-danger fs-12 mt-1">{fileError}</p>
                            )}

                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-outline-light border me-2"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => {
                          if (!projectName || !clientId) {
                            toast.warning(
                              "Please fill in required fields like Project Name and Client"
                            );
                            return;
                          }

                          memberTabRef.current?.click();
                        }}
                      >
                        Next
                      </button>
                    </div>
                  </form>
                </div>
                <div
                  className="tab-pane fade"
                  id="member"
                  role="tabpanel"
                  aria-labelledby="member-tab"
                  tabIndex={0}
                >
                  <form>
                    <div className="modal-body">
                      <div className="row">
                        {/* Team Members */}
                        <div className="col-md-12 mb-3">
                          <label className="form-label me-2">
                            Team Members
                          </label>
                          <Select
                            options={employeeOptions}
                            isMulti
                            value={teamMembers}
                            onChange={handleMultiSelect(setTeamMembers)}
                          />
                        </div>

                        {/* Team Leader */}
                        <div className="col-md-12 mb-3">
                          <label className="form-label me-2">Team Leader</label>
                          <Select
                            options={employeeOptions}
                            isMulti
                            value={teamLeader}
                            onChange={handleMultiSelect(setTeamLeader)}
                          />
                        </div>

                        {/* Project Manager */}
                        <div className="col-md-12 mb-3">
                          <label className="form-label me-2">
                            Project Manager
                          </label>
                          <Select
                            options={employeeOptions}
                            isMulti
                            value={projectManager}
                            onChange={handleMultiSelect(setProjectManager)}
                          />
                        </div>

                        {/* Tags (Multi-select) */}
                        {/* <div className="col-md-12 mb-3">
                          <label className="form-label">Tags</label>
                          <Select
                            options={employeeOptions}
                            isMulti
                            value={tags}
                            onChange={handleMultiSelect(setTags)}
                          />
                        </div> */}

                        {/* Status */}
                        <div className="col-md-12 mb-3">
                          <label className="form-label">Status</label>
                          <Select
                            className="select"
                            options={statusChoose}
                            value={statusChoose.find(
                              (opt) => opt.value === status
                            )}
                            onChange={handleSingleSelect(setStatus)}
                          />
                        </div>

                        <div className="modal-footer">
                          <div className="d-flex align-items-center justify-content-end">
                            <button
                              type="button"
                              className="btn btn-outline-light border me-2"
                              data-bs-dismiss="modal"
                            >
                              Cancel
                            </button>
                            <button
                              className="btn btn-primary"
                              type="button"
                              onClick={handleSubmit}
                              data-bs-dismiss="modal"
                            >
                              Save
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Add Project */}

      {/* Add Project Success */}
      <div className="modal fade" id="success_modal" role="dialog">
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content">
            <div className="modal-body">
              <div className="text-center p-3">
                <span className="avatar avatar-lg avatar-rounded bg-success mb-3">
                  <i className="ti ti-check fs-24" />
                </span>
                <h5 className="mb-2">Project Added Successfully</h5>
                <p className="mb-3">
                  Stephan Peralt has been added with Client ID :{" "}
                  <span className="text-primary">#pro - 0004</span>
                </p>
                <div>
                  <div className="row g-2">
                    <div className="col-6">
                      <Link
                        to={all_routes.project}
                        className="btn btn-dark w-100"
                      >
                        Back to List
                      </Link>
                    </div>
                    <div className="col-6">
                      <Link
                        to={all_routes.projectdetails}
                        className="btn btn-primary w-100"
                      >
                        Detail Page
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Add Project Success */}
    </>

  )
}

export default Project
